export enum LogEntryLevel {
    DEBUG = 'debug',
    INFO = 'info',
    ERROR = 'error'
}

export class LogEntry {

    private static readonly ENTRY_REGEX = /\[([^\]]+)\]\s+([^\(]+)\(([^)]*)\)\s*(.*)/;

    public module: string = "";
    public method: string = "";
    public params: Record<string, string> = {};
    public details: string;
    public date: Date;

    public static create(time: string, level: string, rawMethod: string, rawDataType?: string, rawData?: string): LogEntry {
        const logEntry = new LogEntry(time, level, rawMethod, rawDataType, rawData);
        const match = rawMethod.match(LogEntry.ENTRY_REGEX);
        if (!match) return;
        logEntry.module = match[1].trim();
        logEntry.method = match[2].trim();
        logEntry.params = logEntry.extractParams(match[3]);
        logEntry.details = match[4];
        return logEntry;
    }

    public static manualCreate(time: string, level: string, module: string, method: string, params: Record<string, string>, details?: string, rawDataType?: string, rawData?: string): LogEntry {
        const logEntry = new LogEntry(time, level, undefined, rawDataType, rawData);
        logEntry.module = module;
        logEntry.method = method;
        logEntry.params = params;
        logEntry.details = details;
        return logEntry;
    }

    private constructor(public time: string, public level: string, public rawMethod?: string, public rawDataType?: string, public rawData?: string) {
        this.date = new Date(time);
    }

    private extractParams(params: string): Record<string, string> {
        if (!params) return {};
        const result: Record<string, string> = {};
        for (const entry of params.split(",")) {
            const colonIndex = entry.indexOf(":");
            if (colonIndex === -1) continue;
            const key = entry.slice(0, colonIndex).trim();
            if (key) result[key] = entry.slice(colonIndex + 1).trim(); ;
        }
        return result;
    }
}
